/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { createRoute } from '@gh/builder-shared';
import { StlListComponent } from './components/stl-list/stl-list.component';
import { StlBusinessService } from './resources/stl-business.service';

const routes: Routes = [createRoute({
  component: StlListComponent,
  path: '',
  init: StlBusinessService,
  auth: {
    permission: 'ScheduleTaskLog.VIEW',
  },
})];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  declarations: [],
  exports: [RouterModule],
})
export class BuilderStlRoutingModule {
}
